import { useCallback, useEffect, useState } from 'react'
import { Card, Col, Form, Row } from 'react-bootstrap'
import MenuItem from '@mui/material/MenuItem'
import { useDispatch } from 'react-redux'

/** TRANSLATION */
import { useTranslation } from 'react-i18next'

/** API */
import HandInsuranceAPI from 'api/setting/doctor-fee-managements/hand-insurance.api'

/** STYLE */
import useStyles from 'features/setting/doctor-fee-managements/hand-insurances/style'

/** UTILS || SLICE */
import { submitModal, unSubmitModal, showModal, resetModal } from 'app/slice/modal.slice'
import { isCreate, isDelete, isUpdate, isView } from 'utils/verification.utils'

/** COMPONENT */
import { swalActive } from 'component/Alert/Swal'
import ButtonCustom from 'component/Button/ButtonCustom'
import HeaderCard from 'component/CardCustom/HeaderCard'
import InputTextField from 'component/Input/InputTextField'
import InputTextSearch from 'component/Input/InputTextSearch'
import ModalCustom from 'component/ModalCustom/ModalCustom'
import TableCustom from 'component/Table/TableCustom'
import { notiSuccess, notiError } from 'component/notifications/notifications'
import TableRowCommon from 'component/Table/TableRowCommon'
import FilterSelect from 'component/Select/FilterSelect'
import { numberFormat } from 'utils/app.utils'
import PageModal from 'new-components/modal/page-modal'
import { Box, Typography } from '@mui/material'
import TextInput from 'new-components/inputs/text-input'
import SnackbarComponent from 'new-components/snackbar/snackbar-component'
import SwitchButton from 'new-components/buttons/switch-button'
import AlertModal from 'new-components/modal/alert-modal'
import {
  isHandInsuranceHourValid,
  isHandInsurancePriceValid,
  isHandInsuranceValueValid,
  resolveHandInsuranceErrorMessage
} from './hand-insurance.validation'

const permissions = {
  isCreate: isCreate(),
  isDelete: isDelete(),
  isUpdate: isUpdate(),
  isView: isView()
}

const initStateErrorMessage = {
  HAND_INSURANCE_HOUR: ``,
  IS_DUPLICATE_HAND_INSURANCE_HOUR: ``,
  HAND_INSURANCE_HOUR_STRING_BASE: ``,
  HAND_INSURANCE_HOUR_STRING_EMPTY: ``,
  HAND_INSURANCE_HOUR_MAXIMUM_LENGTH: ``,
  HAND_INSURANCE_HOUR_ANY_REQUIRED: ``,
  HAND_INSURANCE_HOUR_GREATER_THAN_ZERO: ``,
  HAND_INSURANCE_HOUR_RANGE: ``,

  HAND_INSURANCE_PRICE: ``,
  IS_DUPLICATE_HAND_INSURANCE_PRICE: ``,
  HAND_INSURANCE_PRICE_STRING_BASE: ``,
  HAND_INSURANCE_PRICE_STRING_EMPTY: ``,
  HAND_INSURANCE_PRICE_MAXIMUM_LENGTH: ``,
  HAND_INSURANCE_PRICE_ANY_REQUIRED: ``,
  HAND_INSURANCE_PRICE_GREATER_THAN_ZERO: ``,
  HAND_INSURANCE_PRICE_RANGE: ``
}
export default function HandInsurance() {
  const classes = useStyles()
  const { t, i18n } = useTranslation()
  const dispatch = useDispatch()

  const [handInsurances, setHandInsurances] = useState([])

  const [handInsuranceId, setHandInsuranceId] = useState(Number)
  const [hour, setHour] = useState('')
  const [price, setPrice] = useState('')
  const [handInsuranceStatus, setHandInsuranceStatus] = useState('')

  const [errorMessage, setErrorMessage] = useState(initStateErrorMessage)

  /** PAGINATION  */
  const [page, setPage] = useState(1)
  const [pageLimit, setPageLimit] = useState(10)
  const [rowCount, setRowCount] = useState(0)
  const [sortBy, setSortBy] = useState('createAt')
  const [sortType, setSortType] = useState('ASC')
  const [search, setSearch] = useState('')
  const [status, setStatus] = useState('ALL')

  const [isOpenAlertModal, setIsOpenAlertModal] = useState(false)
  const [statusAlertModal, setStatusAlertModal] = useState('')
  const [id, setId] = useState<number>(0)
  const [name, setName] = useState('')
  const [isOpenModal, setIsOpenModal] = useState(false)
  const [isOpenSnack, setIsOpenSnack] = useState(false)
  const [typeSnack, setTypeSnack] = useState<any>("success")
  const [labelSnack, setLabelSnack] = useState('')

  const loadData = useCallback(async () => {

    let condition: any = {}
    if (page) condition = { ...condition, page: page }
    if (pageLimit) condition = { ...condition, pageLimit: pageLimit }
    if (search) condition = { ...condition, search: search }
    if (sortBy) condition = { ...condition, sortBy: sortBy }
    if (sortType) condition = { ...condition, sortType: sortType }
    if (status) condition = { ...condition, status: status === 'ALL' ? '' : status }
    const respHandInsurances = await HandInsuranceAPI.findAll(condition)
    if (respHandInsurances.status === 200) {
      setRowCount(respHandInsurances.headers['x-total'])
      setHandInsurances(respHandInsurances.data)
    }
  }, [page, pageLimit, search, sortBy, sortType, status])

  useEffect(() => {
    loadData()
  }, [loadData])

  const validateForm = () => {
    const nextErrorMessage = { ...initStateErrorMessage }

    if (!hour) {
      nextErrorMessage.HAND_INSURANCE_HOUR = t(`HAND_INSURANCE.MESSAGE.HAND_INSURANCE_HOUR`)
    } else if (!isHandInsuranceValueValid(hour)) {
      nextErrorMessage.HAND_INSURANCE_HOUR_GREATER_THAN_ZERO = t(`HAND_INSURANCE.MESSAGE.HAND_INSURANCE_HOUR_GREATER_THAN_ZERO`)
    } else if (!isHandInsuranceHourValid(hour)) {
      nextErrorMessage.HAND_INSURANCE_HOUR_RANGE = t(`HAND_INSURANCE.MESSAGE.HAND_INSURANCE_HOUR_RANGE`)
    }

    if (!price) {
      nextErrorMessage.HAND_INSURANCE_PRICE = t(`HAND_INSURANCE.MESSAGE.HAND_INSURANCE_PRICE`)
    } else if (!isHandInsuranceValueValid(price)) {
      nextErrorMessage.HAND_INSURANCE_PRICE_GREATER_THAN_ZERO = t(`HAND_INSURANCE.MESSAGE.HAND_INSURANCE_PRICE_GREATER_THAN_ZERO`)
    } else if (!isHandInsurancePriceValid(price)) {
      nextErrorMessage.HAND_INSURANCE_PRICE_RANGE = t(`HAND_INSURANCE.MESSAGE.HAND_INSURANCE_PRICE_RANGE`)
    }

    setErrorMessage(nextErrorMessage)
    return Boolean(
      nextErrorMessage.HAND_INSURANCE_HOUR ||
      nextErrorMessage.HAND_INSURANCE_HOUR_GREATER_THAN_ZERO ||
      nextErrorMessage.HAND_INSURANCE_HOUR_RANGE ||
      nextErrorMessage.HAND_INSURANCE_PRICE ||
      nextErrorMessage.HAND_INSURANCE_PRICE_GREATER_THAN_ZERO ||
      nextErrorMessage.HAND_INSURANCE_PRICE_RANGE
    )
  }

  const showApiError = (error: any) => {
    const message = error?.response?.data?.message || error?.message
    const label = resolveHandInsuranceErrorMessage(
      message,
      (key) => i18n.exists(key),
      (key) => t(key)
    )

    if (typeof message === 'string') {
      setErrorMessage((current) => ({ ...current, [message]: label }))
    }
    setIsOpenSnack(true)
    setTypeSnack('error')
    setLabelSnack(label)
  }

  const submit = () => {
    if (validateForm()) return
    HandInsuranceAPI.create(hour, price)
      .then((res: any) => {
        if (res.status !== undefined && res.status === 201) {
          setIsOpenModal(false)
          setIsOpenSnack(true)
          setTypeSnack('success')
          setLabelSnack(t('HAND_INSURANCE.MESSAGE.SUCCESS.CREATE'))
          resetForm()
          loadData()
        } else {
          showApiError(res)
        }
      })
      .catch((e) => {
        showApiError(e)
      })
  }

  const submitEdit = () => {
    if (validateForm()) return

    HandInsuranceAPI.update(handInsuranceId, hour, price, handInsuranceStatus)
      .then((res: any) => {
        if (res.status !== undefined && res.status === 200) {
          setIsOpenModal(false)
          setIsOpenSnack(true)
          setTypeSnack('success')
          setLabelSnack(t('HAND_INSURANCE.MESSAGE.SUCCESS.UPDATE'))
          resetForm()
          loadData()
        } else {
          showApiError(res)
        }
      })
      .catch((e) => {
        showApiError(e)
      })
  }

  const clearErrorMessage = () => {
    setErrorMessage(initStateErrorMessage)
  }

  const resetForm = () => {
    setHandInsuranceId(0)
    setHour('')
    setPrice('')
    setHandInsuranceStatus('')

    clearErrorMessage()
  }
  const onActive = () => {
    if (id) {
      HandInsuranceAPI.updateStatus(id, statusAlertModal).then((resp) => {
        if (resp.status === 200) {
          setIsOpenAlertModal(false)
          setIsOpenSnack(true)
          setTypeSnack("success")
          setLabelSnack(t('HAND_INSURANCE.MESSAGE.SUCCESS.UPDATE_STATUS'))
          loadData()
        } else {
          setIsOpenAlertModal(false)
          setIsOpenSnack(true)
          setTypeSnack("error")
          setLabelSnack(t('HAND_INSURANCE.MESSAGE.ERROR'))
        }
      })
    }
  }
  const onDelete = () => {
    if (id) {
      HandInsuranceAPI.remove(id).then((resp) => {
        if (resp.status === 200) {
          setIsOpenAlertModal(false)
          setIsOpenSnack(true)
          setTypeSnack("success")
          setLabelSnack(t('HAND_INSURANCE.MESSAGE.SUCCESS.DELETE'))
          loadData()
        } else {
          setIsOpenAlertModal(false)
          setIsOpenSnack(true)
          setTypeSnack("error")
          setLabelSnack(t('HAND_INSURANCE.MESSAGE.ERROR'))
        }
      })
    }
  }

  const onEdit = (data: any) => {
    const { handInsuranceId: handInsId, hour: handInsHour, price: handInsPrice, status: handInsStatus } = data
    setHandInsuranceId(handInsId)
    setHour(handInsHour)
    setPrice(handInsPrice)
    setHandInsuranceStatus(handInsStatus)
    clearErrorMessage()
    setIsOpenModal(true)
  }

  const onRequestSort = (sortByVal: string, sortTypeVal: string) => {
    setSortType(sortTypeVal)
    setSortBy(sortByVal)
  }

  const handleChangePage = (val: number) => {
    setPage(val)
  }

  const handleChangeRowsPerPage = (limit: number) => {
    setPageLimit(limit)
  }

  const handleChangeStatus = (statusVal: string) => {
    setStatus(statusVal)
  }

  const headCells = [
    { id: 'no', disablePadding: false, label: '#', width: '80px' },
    { id: 'hour', disablePadding: false, label: t('HAND_INSURANCE.TABLE.CELL.HOUR'), align: 'center', class: 'text-nowrap' },
    { id: 'price', disablePadding: false, label: t('HAND_INSURANCE.TABLE.CELL.PRICE'), class: 'text-nowrap' },
    { id: 'status', disablePadding: false, label: t('HAND_INSURANCE.TABLE.CELL.STATUS') },
    { id: 'updatedBy', disablePadding: false, label: t('HAND_INSURANCE.TABLE.CELL.UPDATED_BY') },
    { id: 'action', disablePadding: false, label: 'Action', width: '100px' }
  ]

  const renderData = (objData: any, no: number) => {
    no = page * pageLimit - pageLimit + no + 1
    const { handInsuranceId: handInsId, hour: handInsHour, price: handInsPrice, updatedBy, updatedAt, status: handInsStatus } = objData

    const statusBtnActive = handInsStatus === 'ACTIVE' ? true : permissions.isUpdate.disabled
    const statusBtnInActive = handInsStatus === 'INACTIVE' ? true : permissions.isUpdate.disabled

    const objRenderData = {
      key: handInsId,
      id: handInsId,
      obj: objData,
      columns: [
        { option: 'TEXT', align: 'center', label: no },
        { option: 'TEXT', align: 'center', label: handInsHour },
        { option: 'TEXT', align: 'right', label: numberFormat(handInsPrice) },
        { option: 'STATUS', align: 'center', label: handInsStatus },
        { option: 'UPDATE_BY', align: 'center', label: { updatedBy: updatedBy, updatedAt: updatedAt } },

        {
          option: 'ACTION',
          align: 'center',
          label: 'action',
          values: [
            { option: 'STATUS_ACTIVE', label: t(`STATUS.ACTIVE`), disabled: statusBtnActive },
            { option: 'STATUS_INACTIVE', label: t(`STATUS.INACTIVE`), disabled: statusBtnInActive },
            { option: 'DIVIDER', label: '', disabled: false },
            { option: 'EDIT', label: t(`BUTTON.EDIT`), disabled: permissions.isUpdate.disabled },
            { option: 'DELETE', label: t(`BUTTON.DELETE`), disabled: permissions.isDelete.disabled }
          ]
        }
      ]
    }
    return (
      <TableRowCommon
        {...objRenderData}
        onactive={() => handleSubmitModal(Number(objRenderData.id), 'ACTIVE', objRenderData.obj)}
        oninactive={() => handleSubmitModal(Number(objRenderData.id), 'INACTIVE', objRenderData.obj)}
        onedit={() => onEdit(objRenderData.obj)}
        ondelete={() => handleSubmitModal(Number(objRenderData.id), 'DELETE', objRenderData.obj)}
      />
    )
  }

  const handleSubmitModal = (id: number, status: string, obj?: any) => {
    setStatusAlertModal(status)
    setId(obj.handInsuranceId)
    setIsOpenAlertModal(true)
  }

  return (
    <div className={classes.root}>
      <AlertModal
        isOpen={isOpenAlertModal}
        title={t(`HAND_INSURANCE.ALERT.${statusAlertModal === 'DELETE' ? 'TITLE_DELETE' : 'TITLE_ACTIVE'}`)}
        message={t(`HAND_INSURANCE.ALERT.${statusAlertModal === "DELETE" ? 'CONFIRM_DELETE' : 'CONFIRM_STATUS'}`, { status: t(`HAND_INSURANCE.ALERT.${statusAlertModal}`) })}
        type={statusAlertModal === 'DELETE' ? 'error' : 'warning'}
        handleClose={() => setIsOpenAlertModal(false)}
        onCancel={{ onClick: () => setIsOpenAlertModal(false), title: t('BUTTON.CANCEL') }}
        onSubmit={{ onClick: statusAlertModal === 'DELETE' ? onDelete : onActive, title: t('BUTTON.SUBMIT') }}
      />
      <SnackbarComponent
        onOpen={isOpenSnack}
        onClose={() => setIsOpenSnack(false)}
        label={labelSnack}
        type={typeSnack}
        transform={`translateX(calc(100vw - 100% - 32px)) translateY(calc(-100vh + 100% + ${window.innerHeight - 50}px))`}
        autoHideTime={3000}
      />
      <PageModal
        handleClose={() => setIsOpenModal(false)}
        isOpen={isOpenModal}
        title={handInsuranceId ? t('HAND_INSURANCE.TITLE_UPDATE') : t('HAND_INSURANCE.TITLE_CREATE')}
        size='XS'
        onCancel={{ onClick: () => setIsOpenModal(false) }}
        onSubmit={{
          onClick: () => {
            handInsuranceId ? submitEdit() : submit()
          }
        }}
      >
        <Box marginTop="16px">
          {handInsuranceId !== 0 && <Box display="flex" justifyContent="space-between" alignItems="center" marginBottom="16px">
            <Typography fontSize="16px" fontWeight={400}>สถานะการใช้งาน</Typography>
            <SwitchButton checked={handInsuranceStatus === 'ACTIVE' ? true : false} onChange={(e) => setHandInsuranceStatus(handInsuranceStatus === 'ACTIVE' ? 'INACTIVE' : 'ACTIVE')} />
          </Box>}
          <Box display="flex" flexDirection="column" gap="16px">
            <TextInput
              onChange={(event) => {
                setHour(event.target.value)
                clearErrorMessage()
              }}
              value={hour}
              label={t('HAND_INSURANCE.INPUT.HAND_INSURANCE_HOUR')}
              fullWidth
              helperText={
                errorMessage.HAND_INSURANCE_HOUR ||
                errorMessage.IS_DUPLICATE_HAND_INSURANCE_HOUR ||
                errorMessage.HAND_INSURANCE_HOUR_STRING_BASE ||
                errorMessage.HAND_INSURANCE_HOUR_STRING_EMPTY ||
                errorMessage.HAND_INSURANCE_HOUR_MAXIMUM_LENGTH ||
                errorMessage.HAND_INSURANCE_HOUR_ANY_REQUIRED ||
                errorMessage.HAND_INSURANCE_HOUR_GREATER_THAN_ZERO ||
                errorMessage.HAND_INSURANCE_HOUR_RANGE
              }
              required
              inputProps={{ value: hour }}
            />
            <TextInput
              onChange={(event) => {
                setPrice(event.target.value)
                clearErrorMessage()
              }}
              helperText={
                errorMessage.HAND_INSURANCE_PRICE ||
                errorMessage.IS_DUPLICATE_HAND_INSURANCE_PRICE ||
                errorMessage.HAND_INSURANCE_PRICE_STRING_BASE ||
                errorMessage.HAND_INSURANCE_PRICE_STRING_EMPTY ||
                errorMessage.HAND_INSURANCE_PRICE_MAXIMUM_LENGTH ||
                errorMessage.HAND_INSURANCE_PRICE_ANY_REQUIRED ||
                errorMessage.HAND_INSURANCE_PRICE_GREATER_THAN_ZERO ||
                errorMessage.HAND_INSURANCE_PRICE_RANGE
              }
              label={t('HAND_INSURANCE.INPUT.HAND_INSURANCE_PRICE')}
              required
              fullWidth
              inputProps={{ value: price }}
            />
          </Box>
        </Box>
      </PageModal>
      <Card className="border-0 h-100">
        <HeaderCard text={t('HAND_INSURANCE.TITLE')} />
        <Card.Body>
          <Card.Title className={'mb-0 pl-xl-3'}>
            <Row className="align-items-center">
              <Col md={8}>
                <Row className="flax-row">
                  <Col sm={12} md={6} xl={4} className="pt-2">
                    <InputTextSearch
                      keyInput={'search'}
                      label={t('HAND_INSURANCE.SEARCH')}
                      value={search}
                      onchange={(event) => {
                        setSearch(event.target.value)
                        setPage(1)
                      }}
                      onClear={(event) => {
                        setSearch('')
                        setPage(1)
                      }}
                    />
                  </Col>
                  <Col sm={12} md={6} xl={4} className="pl-md-0 pt-2">
                    <FilterSelect
                      onchange={(event) => {
                        const value = event.target.value
                        if (value) {
                          handleChangeStatus(value)
                          setPage(1)
                        }
                      }}
                      renderValue={() => `${t('STATUS.LABEL')}: ${t(`STATUS.${status}`)}`}
                      label={t('STATUS.LABEL')}
                      selectId="select-status"
                      value={status}
                      labelId="label-status"
                      options={[
                        <MenuItem key="1" value="ALL">
                          {t('STATUS.ALL')}
                        </MenuItem>,
                        <MenuItem key="2" value="ACTIVE">
                          {t('STATUS.ACTIVE')}
                        </MenuItem>,
                        <MenuItem key="3" value="INACTIVE">
                          {t('STATUS.INACTIVE')}
                        </MenuItem>
                      ]}
                    />
                  </Col>
                </Row>
              </Col>
              <Col md={4} className="mt-2 mt-md-auto">
                <div className="pr-xl-2">
                  <ButtonCustom mode="add" disabled={permissions.isCreate.disabled} onClick={() => {
                    clearErrorMessage()
                    resetForm()
                    setIsOpenModal(true)
                  }} textButton={t('HAND_INSURANCE.BUTTON.ADD')} className="w-auto ml-auto d-flex mt-auto" />
                </div>
              </Col>
            </Row>
          </Card.Title>

          <div className={'mt-3 pl-xl-3 pr-xl-2'}>
            <TableCustom
              page={page}
              pageLimit={pageLimit}
              sortType={sortType}
              sortBy={sortBy}
              onSort={onRequestSort}
              setPageLimit={handleChangeRowsPerPage}
              setPage={handleChangePage}
              rowCount={rowCount}
              headCells={headCells}
              rowsData={handInsurances.map((val, i) => {
                return renderData(val, i)
              })}
              tableFixedWidth
            />
          </div>
        </Card.Body>
      </Card>

      <ModalCustom
        title={handInsuranceId ? t('HAND_INSURANCE.TITLE_UPDATE') : t('HAND_INSURANCE.TITLE_CREATE')}
        component={
          <div>
            {handInsuranceId ? (
              <div>
                <Form className="mx-0 mt-0 mb-3 p-0  d-inline-flex w-100">
                  <Form.Label className=" mr-auto">{t('INPUT.LABEL_STATUS')}</Form.Label>
                  <Form.Check
                    type="switch"
                    id="custom-switch"
                    onChange={() => setHandInsuranceStatus(handInsuranceStatus === 'ACTIVE' ? 'INACTIVE' : 'ACTIVE')}
                    checked={handInsuranceStatus === 'ACTIVE' ? true : false}
                    style={{ marginLeft: 'auto' }} />
                </Form>
              </div>
            ) : (
              ''
            )}
            <div className="mb-3">
              <InputTextField
                onchange={(event) => {
                  setHour(event.target.value)
                  clearErrorMessage()
                }}
                value={hour}
                label={t('HAND_INSURANCE.INPUT.HAND_INSURANCE_HOUR')}
                helperText={
                  errorMessage.HAND_INSURANCE_HOUR ||
                  errorMessage.IS_DUPLICATE_HAND_INSURANCE_HOUR ||
                  errorMessage.HAND_INSURANCE_HOUR_STRING_BASE ||
                  errorMessage.HAND_INSURANCE_HOUR_STRING_EMPTY ||
                  errorMessage.HAND_INSURANCE_HOUR_MAXIMUM_LENGTH ||
                  errorMessage.HAND_INSURANCE_HOUR_ANY_REQUIRED ||
                  errorMessage.HAND_INSURANCE_HOUR_GREATER_THAN_ZERO ||
                  errorMessage.HAND_INSURANCE_HOUR_RANGE
                }
                required={true}
              />
            </div>

            <InputTextField
              key="price"
              onchange={(event) => {
                setPrice(event.target.value)
                clearErrorMessage()
              }}
              value={price}
              helperText={
                errorMessage.HAND_INSURANCE_PRICE ||
                errorMessage.IS_DUPLICATE_HAND_INSURANCE_PRICE ||
                errorMessage.HAND_INSURANCE_PRICE_STRING_BASE ||
                errorMessage.HAND_INSURANCE_PRICE_STRING_EMPTY ||
                errorMessage.HAND_INSURANCE_PRICE_MAXIMUM_LENGTH ||
                errorMessage.HAND_INSURANCE_PRICE_ANY_REQUIRED ||
                errorMessage.HAND_INSURANCE_PRICE_GREATER_THAN_ZERO ||
                errorMessage.HAND_INSURANCE_PRICE_RANGE
              }
              label={t('HAND_INSURANCE.INPUT.HAND_INSURANCE_PRICE')}
              required={true}
            />
          </div>
        }
        onReset={resetForm}
        onSubmit={handInsuranceId ? submitEdit : submit}
        textBtnCancel={t('HAND_INSURANCE.BUTTON.CANCEL')}
        textBtnConfirm={t('HAND_INSURANCE.BUTTON.SAVE')}
      />
    </div>
  )
}
